import { AuthDispatchers } from '@store/auth/auth.dispatchers';
import { AppCoreDispatchers } from '@store/app-core/app-core.dispatchers';
import { SettingsDispatchers } from '@store/settings';

export const APP_DISPATCHERS = [AuthDispatchers, AppCoreDispatchers, SettingsDispatchers];
